<!--
 * @Descripttion: 首页组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 21:20:08
--> 

<template>
  <div class="home" id="home" name="home">
    <!-- Hero Section -->
    <div class="hero">
      <div class="hero-banner" :style="{ backgroundImage: `url(${currentHeroImage})` }">
        <div class="hero-overlay">
          <div class="hero-title">Rooted in Nature. Styled for Her.</div>
          <div class="hero-desc">
            Handpicked ethnic and everyday womenswear — kurtas, sarees, palazzos and unstitched dress material in breathable cotton and natural weaves. Earthy tones, honest fabrics, made for the modern Indian woman.
          </div>
          <router-link class="hero-btn" to="/goods">Shop Now</router-link>
        </div>
        <div class="hero-dots">
          <span
            v-for="(img, idx) in heroImages"
            :key="idx"
            class="hero-dot"
            :class="{ active: heroIndex === idx }"
            @click="setHeroIndex(idx)"
          ></span>
        </div>
      </div>
    </div>

    <!-- Category Products Section -->
    <div class="main-box">
      <div class="main">
        <div class="section-header">
          <h2>New Arrivals</h2>
          <p>Fresh women's styles just landed</p>
        </div>
        <div class="category-products">
          <ProductGrid :list="homeProducts" :isMore="false"></ProductGrid>
        </div>

        <!-- Why Shop With Us -->
        <div class="why-section">
          <div class="why-item">
            <div class="why-icon">🚚</div>
            <h3>Free Shipping</h3>
            <p>On orders above ₹499</p>
          </div>
          <div class="why-item">
            <div class="why-icon">👔</div>
            <h3>Premium Quality</h3>
            <p>Curated fabrics &amp; fine craftsmanship</p>
          </div>
          <div class="why-item">
            <div class="why-icon">🔄</div>
            <h3>Easy Returns</h3>
            <p>7-day hassle-free returns</p>
          </div>
          <div class="why-item">
            <div class="why-icon">💳</div>
            <h3>Secure Payment</h3>
            <p>UPI, COD &amp; cards accepted</p>
          </div>
        </div>

        <!-- Shop By Category Tiles -->
        <div class="home-section cat-section">
          <div class="home-section-header">
            <div>
              <h2>Shop By Category</h2>
              <p>Eight edits, one wardrobe</p>
            </div>
            <router-link class="section-cta" to="/goods">See All</router-link>
          </div>
          <div class="cat-tiles">
            <router-link
              v-for="tile in categoryTiles"
              :key="tile.id"
              class="cat-tile"
              :to="`/goods?categoryID=${tile.id}`"
            >
              <span class="cat-tile-accent"></span>
              <img :src="tile.img" :alt="tile.name" loading="lazy" />
              <span class="cat-tile-label">{{ tile.name }}</span>
            </router-link>
          </div>
        </div>

        <!-- Discover Section -->
        <div class="home-section">
          <div class="home-section-header">
            <div>
              <h2>Shop The Edit</h2>
              <p>Eight edits from handloom sarees to everyday kurtas</p>
            </div>
            <div class="section-tabs">
              <span
                v-for="tab in discoverTabs"
                :key="tab.key"
                class="tab-item"
                :class="{active: discoverActive===tab.key}"
                @click="discoverActive=tab.key"
              >{{ tab.label }}</span>
            </div>
          </div>
          <ProductGrid :list="discoverProducts" :isMore="false"></ProductGrid>
          <router-link class="section-cta" to="/goods">See More</router-link>
        </div>

        <!-- Full Width Promo Banner -->
        <div class="promo-full-banner">
          <div class="promo-content">
            <span class="promo-tag">Limited Time Offer</span>
            <h2>THE HANDLOOM EDIT</h2>
            <p>Up to 40% Off on Kurtas, Sarees &amp; Dress Material</p>
            <router-link class="promo-btn" to="/goods">Shop Now</router-link>
          </div>
          <div class="promo-image">
            <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/31769430/img_00.jpg" alt="Ekana Women Printed Kurta with Trousers" />
          </div>
        </div>

        <!-- Split Banners -->
        <div class="split-banners-grid">
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Skirts, Palazzos &amp; Bottoms</div>
              <div class="split-desc">
                Flowy palazzos, pleated midi skirts and ankle-length leggings — breathable bottoms that pair with every kurta you own.
              </div>
              <router-link class="section-cta" to="/goods?categoryID=66">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/26867502/img_00.jpg" alt="Ethnovog Printed Pleated Maxi Length Skirt" />
            </div>
          </div>
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Layering for Every Season</div>
              <div class="split-desc">
                Lightweight jackets and hooded layers in natural fabrics — easy warmth for early mornings, hill drives and winter weddings.
              </div>
              <router-link class="section-cta" to="/goods?categoryID=68">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/41376692/img_00.jpg" alt="HRX by Hrithik Roshan Sporty Jacket" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as productsAPI from '@/api/products/'
import * as categoryAPI from '@/api/categories/'
import ProductGrid from '@/components/ProductGrid'

export default {
  components: { ProductGrid },
  data() {
    return {
      carousels: [], // 轮播图数据（后端接口，已忽略：Hero 由下方精选女装图池提供）
      // Discover 区：8 个女装分类 tab（category_id 对应 sql/女装.sql 的 category_id 61-68）
      discoverTabs: [
        { key: 'KURTAS', id: 61, label: 'KURTAS & SUITS' },
        { key: 'TOPS', id: 62, label: 'ETHNIC TOPS' },
        { key: 'SAREE', id: 63, label: 'SAREES' },
        { key: 'ETHNIC', id: 64, label: 'ETHNIC WEAR' },
        { key: 'BOTTOM', id: 65, label: 'BOTTOMWEAR' },
        { key: 'SKIRTS', id: 66, label: 'SKIRTS & PALAZZOS' },
        { key: 'MATERIAL', id: 67, label: 'DRESS MATERIAL' },
        { key: 'JACKETS', id: 68, label: 'JACKETS' }
      ],
      discoverActive: 'KURTAS', // Discover section active tab
      discoverLists: {}, // key -> 商品列表
      // Shop By Category 分类卡片（8 张，来自 sql/女装.sql img_path，OSS shop5 路径）
      categoryTiles: [
        { id: 61, name: 'Kurtas & Kurtis', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/42009214/img_00.jpg' },
        { id: 62, name: 'Ethnic Tops', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/37866980/img_00.jpg' },
        { id: 63, name: 'Sarees', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/41534767/img_00.jpg' },
        { id: 64, name: 'Ethnic Wear', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/39061350/img_00.jpg' },
        { id: 65, name: 'Bottomwear', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/33988497/img_00.jpg' },
        { id: 66, name: 'Skirts & Palazzos', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/40316779/img_00.jpg' },
        { id: 67, name: 'Dress Material', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/40069352/img_00.jpg' },
        { id: 68, name: 'Jackets', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/33357289/img_00.jpg' }
      ],
      // Hero 轮播：精选女装图池（OSS shop5 路径，来自 sql/女装.sql img_path）
      heroImages: [
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/34182437/img_00.jpg', // ZARIKALI Zardozi Organza Kurta Set
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/33532414/img_00.jpg', // RAJGRANTH Sequinned Kurti
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/19066166/img_00.jpg', // Sangria Embroidered Longline Top
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/41233535/img_00.jpg'  // Outzidr Midi Skirt with Lace
      ],
      heroIndex: 0,
      heroTimer: null,
      start: 0,
      limit: 7,
      homeCategories: [],
      activeCategoryId: 0,
      homeProducts: [],
      homeStart: 0,
      homeLimit: 8
    }
  },
  computed: {
    currentHeroImage() {
      // 直接使用精选男装图池，忽略后端 carousels
      return this.heroImages[this.heroIndex] || this.heroImages[0]
    },
    discoverProducts() {
      return this.discoverLists[this.discoverActive] || []
    }
  },
  activated() {
    // 获取首页数据
    this.load()
    this.startHeroRotation()
  },
  deactivated() {
    this.stopHeroRotation()
  },
  beforeDestroy() {
    this.stopHeroRotation()
  },
  methods: {
    // Hero 轮播控制
    setHeroIndex(idx) {
      this.heroIndex = idx
    },
    startHeroRotation() {
      this.stopHeroRotation()
      if (!this.heroImages || this.heroImages.length < 2) return
      this.heroTimer = setInterval(() => {
        this.heroIndex = (this.heroIndex + 1) % this.heroImages.length
      }, 5000)
    },
    stopHeroRotation() {
      if (this.heroTimer) {
        clearInterval(this.heroTimer)
        this.heroTimer = null
      }
    },
    load() {
      // 不再请求后端 carousels 接口。Hero 轮播由精选男装图池提供。
      // 首页类目：取导航“Shop Now”同源分类
      categoryAPI
        .listCategories()
        .then(res => {
          if (res.status === 200) {
            const list = Array.isArray(res.data) ? res.data : []
            this.homeCategories = [{ category_id: 0, category_name: 'All' }, ...list]
            this.activeCategoryId = 0
            this.fetchHomeProducts(0)
          } else {
            this.notifyError('Failed to obtain classification', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain classification', err)
        })
      // Discover section: 8 个男装分类（类别 id 直接用 product_cat_id 31-38）
      this.loadDiscover()
    },
    // Discover 区：按 8 个 tab 拉取商品
    loadDiscover() {
      this.discoverTabs.forEach(tab => {
        productsAPI
          .listProducts(tab.id, 0, this.limit)
          .then(res => {
            if (res.status === 200) {
              this.$set(this.discoverLists, tab.key, this.shuffle((res.data && res.data.items) || []))
            }
          })
          .catch(() => {})
      })
    },
    fetchHomeProducts(categoryId) {
      productsAPI
        .listProducts(categoryId, this.homeStart, this.homeLimit)
        .then(res => {
          if (res.status === 200) {
            this.homeProducts = this.shuffle(Array.isArray(res.data.items) ? res.data.items : [])
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // Fisher-Yates shuffle
    shuffle(array) {
      const arr = [...array]
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[arr[i], arr[j]] = [arr[j], arr[i]]
      }
      return arr
    }
  },
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#FFFFFF')
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#FFFFFF')
    next()
  }
}
</script>
<style scoped>
@import '../assets/css/index.css';

/* Shop By Category Tiles（Sonit Style） */
.cat-section .cat-tiles {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin: 8px 0 44px;
}
.cat-section .cat-tile {
  position: relative;
  display: block;
  border-radius: 14px;
  overflow: hidden;
  background: #FAF7F1;
  text-decoration: none;
}
.cat-section .cat-tile img {
  width: 100%;
  height: 230px;
  object-fit: cover;
  display: block;
  transition: transform 0.35s ease;
}
.cat-section .cat-tile:hover img {
  transform: scale(1.05);
}
.cat-section .cat-tile-accent {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  width: 36px;
  height: 4px;
  border-radius: 2px;
  background: #C2703D;
}
.cat-section .cat-tile-label {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 22px 14px 12px;
  background: linear-gradient(180deg, rgba(18, 53, 42, 0) 0%, rgba(18, 53, 42, 0.85) 100%);
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
}
@media (max-width: 900px) {
  .cat-section .cat-tiles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .cat-section .cat-tile img {
    height: 160px;
  }
}
</style>
